<template>
  <div>
    <Menu></Menu>
    <div class="card">
      <div class="item item-text-wrap">
          Manage your account's settings on this page.
      </div>
    </div>

    <div class="padding">
        Choose the interval between you wish to be notified of new episodes of the story.
        <p>This app can notify you by email when there is a new episode for you to read.</p>
        <form>
          <div class="field">
            <label class="radio">
              <input type="radio" name="5min" class="control" :value="5" v-model="episode_interval">
              5 Minutes
            </label>
            <label class="radio">
              <input type="radio" name="1hr" class="control" :value="60" v-model="episode_interval">
              1 Hour
            </label>
            <label class="radio">
              <input type="radio" name="1day" class="control" :value="1440" v-model="episode_interval">
              1 Day
            </label>
          </div>
        </form>
        <ion-toggle v-model="settings.notify" toggle-class="toggle-calm">Send e-mail for new episodes</ion-toggle>

        <button class="button button-block button-stable" ui-sref="app.changepassword">Change password</button>
        <button class="button button-block button-stable" ng-click="confirmReset()">Reset journey</button>

        <ion-toggle v-model="settings.debug" toggle-class="toggle-calm">Developer mode</ion-toggle>
    </div>
  </div>
</template>

<script>
import { updateProgress } from '@/firebaseService.js'
export default {

  name: 'Settings',

  data () {
    return {
      settings: {
        episode_intervalProxy: null,
        debug: false,
        notify: true
      }
    }
  },
  computed: {
    episode_interval: {
      get () {
        return this.$root.progress.episode_interval
      },
      set (val) {
        this.settings.episode_intervalProxy = val
      }
    }
  },
  watch: {
    settings: {
      handler (to) {
        if (this.settings.episode_intervalProxy) {
          var update = { episode_interval: this.settings.episode_intervalProxy }
          updateProgress(update)
        }
      },
      deep: true
    }
  },
  components: {
  },
  methods: {
    // Triggered when `childToParent` event is emitted by the child.
    onChildClick (value) {
      this.episode_interval = value
    }
  }
}
</script>

<style lang="css" scoped>
</style>
